import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/profile-settings')({
  beforeLoad: () => getTitleContextSlice('Profile Settings'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
